<template>
  <div id="site-app" :class="routePageClass">
    <PageHeader />
    <router-view />
    <PageFooter />
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue';
import PageFooter from '@/components/PageFooter.vue';

export default {
  name: 'App',
  components: {
    PageHeader,
    PageFooter,
  },
  computed: {
    routePageClass() {
      const name = String(this.$route.name || 'home')
        .replace(/View$/, '')
        .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
        .toLowerCase();

      if (name === 'home') return 'home-page';
      return 'internal-page page-' + name;
    },
  },
};
</script>
